module.exports = "/_next/static/files/cb9e47f01be772774d023487058e7f21.png";